(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-colecciones-relacionadas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-collections')) {
    customElements.define('related-collections', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rc-track]');
        this.nav = this.querySelector('[data-rc-nav]');
        if (!this.track || !this.nav) return;

        this.prev = this.nav.querySelector('[data-rc-prev]');
        this.next = this.nav.querySelector('[data-rc-next]');
        this.ticking = false;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.update(); this.ticking = false; });
        };
        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);

        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
      }

      move(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const t = this.track;
        const overflow = t.scrollWidth > t.clientWidth + 1;
        this.nav.hidden = !overflow;
        if (!overflow) return;
        this.prev.disabled = t.scrollLeft <= 1;
        this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
